import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import VueZoomer from 'vue-zoomer';
import vue3GoogleLogin from 'vue3-google-login';
import VueAxios from 'vue-axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import SplitCarousel from "vue-split-carousel";
import VueToast from 'vue-toast-notification';
import { createHead, VueHeadMixin } from '@unhead/vue'

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from './methods/axios.js'

import { store } from "./store/storeModules.js";
import PriceFormatter from "./plugins/PriceFormatter.js"
import DateFormatter from "./plugins/DateFormatter.js"
import FileSource from "./plugins/FileSource.js"
import Slugerize from "./plugins/Slugerize.js"
import { timeFormatter } from './methods/timeFormatter.js'
import { currency } from './methods/currencyFilter.js'

import "./icons/iconsSolid.js";
import "./icons/iconsRegular.js";
import "./icons/iconsBrands.js";

import 'vue-toast-notification/dist/theme-sugar.css';

const myPlugin = {
  install(app, options) {
    document.dispatchEvent(new Event('prerender'))
  }
}
const app = createApp(App);
app.config.globalProperties.$timeFormatter = timeFormatter;
app.config.globalProperties.$currency = currency;
const gAuthOptions = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
};
app.use(vue3GoogleLogin, gAuthOptions)


router.beforeEach((to, from) => {
  /* 給 app 的 web view */
  if (store.state.appView.view) {
    store.commit('changeAppView', false);
  }
  // App WebView：isapp=1 與 isapp=true 都視為 App 模式
  if (to.query.isapp === 'true' || to.query.isapp === '1' || to.query.isapp === 1) {
    switch (to.name) {
      case 'About':
      case 'FAQ':
      case 'ServiceTerms':
      case 'PrivacyTerms':
      case 'Contact':
      case 'Cooperate':
      case 'DeleteAccount':
      case 'TicketSeats':
        store.commit('changeAppView', true);
        break;
    }
  }
  /* 預設跳頁時滾動到頂部，以下條件除外， */
  switch (to.name) {
    case 'News':
    case 'BuyTicket':
    case 'BuyTicketType':
    case 'BuyTicketCart':
    case 'BuyTicketCheckout':
    case 'Location':
    case 'Notes':
      break;
    default:
      /* 從 activity/detail 跳頁到 BuyTicketSession 不會滾動到頂部 */
      if (to.name === 'BuyTicketSession' && from.path.includes('activity/detail')) {
        break;
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      break;
  }
  store.commit("forceCloseModal")
})

const head = createHead()
app.mixin(VueHeadMixin)

app.use(VueZoomer)
  .use(router)
  .use(store)
  .use(PriceFormatter)
  .use(FileSource)
  .use(VueToast)
  .use(Slugerize)
  .use(DateFormatter)
  .use(SplitCarousel)
  .use(VueAxios, axios)
  .use(VueReCaptcha,
    {
      siteKey: '6LdE9uYoAAAAAJwMDyxwitIUtk__8nDfSzEdcYw1',
      loaderOptions: {
        autoHideBadge: true,
      }
    }
  )
  .use(head)
  .use(myPlugin)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("Loading", Loading)
  .mount("#app");

export default app